import { useForm } from "react-hook-form";
import { Button, Form, FormGroup, Modal } from "react-bootstrap";
import { DashCircle, Envelope, ExclamationTriangleFill } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSms } from "@fortawesome/free-solid-svg-icons";
import { sendSMS, sendSMS_Template, setErrorDialog, translateError } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getSMSTemplates } from "../../BaseInfo/store/api/SMSApi";

const ModalSendSMS = (props) => {
    const dispatch = useDispatch();
    const [showTo, setToShow] = useState(true);
    const [smsText, setSMSText] = useState("");
    const [templates, getTemplates] = useState([]);
    const [sendError, setSendError] = useState(null);
    const { register, errors, handleSubmit } = useForm();
    const [numbersCount, setNumbersCount] = useState(0);
    const { popData, setPopData, templateType, sendFromModel } = props;
    const { show, to, filterData, text, onSendOrCancel, sendData } = popData;

    function close() {
        setSendError(null);
        setToShow(true);
        setSMSText("");
        setPopData({
            show: false
        })
        if (onSendOrCancel)
            onSendOrCancel();
    }
    function send(data) {

        setSendError(null);
        const onSend = (data) => {
            if (data.Error) {
                setSendError(translateError(data.Error));
                return;
            }
            setErrorDialog(dispatch, "success", "ارسال پیامک");
            close();
        }
        const tmpName = document.getElementById("TemplateName")?.value;
        if (tmpName !== "" && data.Text.contains("[") && data.Text.contains("]")) {
            data.SendFromModel = sendFromModel;
            if (sendFromModel?.toLowerCase() === "customer") {
                data.CustomerFilters = filterData;
            }
            else if (sendFromModel?.toLowerCase() === "precustomer") {
                data.PreCustomerFilters = filterData;
            }
            else if (Array.isArray(sendData) && sendData.length > 0) {
                data.Templates = sendData;
            }
        }
        else {
            data.To = data.To.split(",");
        }
        if (tmpName !== "" && data.Text.contains("[") && data.Text.contains("]")) {
            sendSMS_Template(data, onSend);

        }
        else {
            sendSMS(data, onSend);
        }
    }
    useEffect(() => {
        if (to && to.length > 0) {
            setNumbersCount((to.match(/,/g) || []).length + 1);
        }
        const onSuccess = (data) => {
            if (Array.isArray(data?.Data??"")) {
                getTemplates(data.Data);
            }
        }

        if (show) {
            document.documentElement.style.overflow = "hidden";
            if (sendFromModel || templateType || Array.isArray(sendData)) {
                getSMSTemplates(templateType, onSuccess);
            }
        }
        else {
            document.documentElement.style.overflow = "unset";
        }
        if (text) {
            setSMSText(text);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <div>
                    <FontAwesomeIcon icon={faSms} size="lg" style={{ float: "right" }} />
                    &nbsp;
                    ارسال پیامک
                </div>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {sendError && <div><small className="errors">{sendError}</small></div>}
                <form onSubmit={handleSubmit(send)}>
                    {showTo &&
                        <FormGroup>
                            <label>شماره همراه مقصد</label>
                            <Form.Control name="To" ref={register({ required: true })} defaultValue={to ?? ""} style={{ textAlign: "left" }} />
                            {to && <small style={{ color: "blue" }}>تعداد شماره ها:{numbersCount}</small>}
                            {errors && errors.To && <small className="errors">شماره مقصد الزامی است</small>}
                        </FormGroup>
                    }
                    {(sendFromModel || Array.isArray(sendData)) &&
                        <FormGroup>
                            <label>قالب پیامک</label>
                            <select className="form-control" id="TemplateName" onChange={e => { setSMSText(e.target.value); setToShow(e.target.value === "") }}>
                                <option value="">انتخاب کنید</option>
                                {templates && Array.isArray(templates) &&
                                    templates.map((tmp, i) => <option key={i} value={tmp.SMSBody}>{tmp.SMSTitle}</option>)
                                }
                            </select>
                        </FormGroup>
                    }
                    <FormGroup>
                        <label>متن پیامک</label>
                        <Form.Control as="textarea" type="text" name="Text" ref={register({ required: true })} value={smsText ?? ""} onChange={e => setSMSText(e.target.value)} />
                        {errors && errors.Text && <small className="errors">متن پیامک الزامی است</small>}
                    </FormGroup>
                    <Button type="submit" variant="success" className="group-Btn mt-2"><Envelope size={15} />&nbsp; ارسال پیامک</Button>
                    <Button variant="danger" className="group-Btn mt-2" onClick={close}><DashCircle size={15} />&nbsp;انصراف</Button>
                </form>
                {showTo &&
                    <div className="mt-2" style={{ padding: 0, color: "blue" }}>
                        <ExclamationTriangleFill color="orange" size={16} />
                        &nbsp;
                        <small>برای ارسال به چند شماره، کافیست شماره ها را با کاما از هم جدا کنید. توجه کنید بین شماره ها فاصله وجود نداشته باشد.</small>
                    </div>
                }
                {!showTo &&
                    <div className="mt-2" style={{ padding: 0, color: "blue" }}>
                        <ExclamationTriangleFill color="orange" size={16} />
                        &nbsp;
                        <small>با انتخاب قالب پیامکی این امکان را به سیستم می دهید که شماره همراه را از اطلاعات صفحه جستجو بدست آورد. بنابراین کادر شماره های مقصد در این حالت پنهان خواهد شد</small>
                    </div>
                }
            </Modal.Body>
        </Modal>
    )

}
export default ModalSendSMS;